import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import myImage from '../assests/images.png'; 
import educationImage from '../assests/szabist.jpg'; 

const AboutUs = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section = document.getElementById('aboutUsSection');
            if (section) {
                const sectionTop = section.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                setIsVisible(sectionTop < windowHeight);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Call once to check initial visibility

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="container mx-auto shadow-lg rounded-md p-8">
            <section id="aboutUsSection" className={`py-12 rounded-md ${isVisible ? 'animate-visible' : ''}`} style={{ backgroundColor: '#393E46', color: 'white' }}>
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-6">
                    <div className="sm:flex items-center">
                        <div className="sm:w-1/2 p-10">
                            <motion.div 
                                className="image object-center text-center"
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={isVisible ? { opacity: 1, scale: 1 } : {}}
                                transition={{ duration: 0.5 }}
                            >
                                <img 
                                    src={myImage} 
                                    alt="About Us" 
                                    style={{ borderRadius: '0 80px 0 80px' }} 
                                    className="border border-white hover:scale-105 transition duration-300"
                                />
                            </motion.div>
                        </div>
                        <div className="sm:w-1/2 p-5">
                            <div className="text">
                                <motion.h2 
                                    className="my-4 font-bold text-3xl sm:text-4xl animate-slide"
                                    initial={{ opacity: 0, x: -50 }}
                                    animate={isVisible ? { opacity: 1, x: 0 } : {}}
                                    transition={{ duration: 0.5, delay: 0.2 }}
                                    style={{ color: 'white' }}
                                >
                                    About <span className="text-blue-500">Work Experience</span>
                                </motion.h2>
                                <motion.p 
                                    className="text-gray-700"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={isVisible ? { opacity: 1, y: 0 } : {}}
                                    transition={{ duration: 0.5, delay: 0.4 }}
                                    style={{ color: 'white' }}
                                >
                                    I have 3 months of experience as a MERN Stack Developer at Uptech Solutions. I have worked on several projects, including a Food Recipes web app.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                
                    <div className="sm:flex items-center mt-10">
                        <div className="sm:w-1/2 p-10">
                            <motion.div 
                                className="image object-center text-center"
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={isVisible ? { opacity: 1, scale: 1 } : {}}
                                transition={{ duration: 0.5 }}
                            >
                                <img 
                                    src={educationImage} 
                                    alt="Education" 
                                    style={{ borderRadius: '0 80px 0 80px' }} 
                                    className="border border-white hover:scale-105 transition duration-300"
                                />
                            </motion.div>
                        </div>
                        <div className="sm:w-1/2 p-5">
                            <div className="text">
                                <motion.h2 
                                    className="my-4 font-bold text-3xl sm:text-4xl animate-slide"
                                    initial={{ opacity: 0, x: -50 }}
                                    animate={isVisible ? { opacity: 1, x: 0 } : {}}
                                    transition={{ duration: 0.5, delay: 0.2 }}
                                    style={{ color: 'white' }}
                                >
                                    About <span className="text-blue-500">Education</span>
                                </motion.h2>
                                <motion.p 
                                    className="text-gray-700"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={isVisible ? { opacity: 1, y: 0 } : {}}
                                    transition={{ duration: 0.5, delay: 0.4 }}
                                    style={{ color: 'white' }}
                                >
                                    I am currently in my 7th semester pursuing a Bachelor's degree in Computer Science at SZABIST. I am passionate about exploring various facets of computer science and eager to continue my journey of learning and growth in this field.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutUs;
